import { zodResolver } from "@hookform/resolvers/zod";
import { VeBox } from "@packages/ui/mui";
import { SubmitHandler, useForm } from "react-hook-form";
import z from "zod";
import { InputModal } from "../../Modal/inputModal";
import { VeInput } from "../../Input/VeInput";

const validationSchema = z.object({
  message: z.string(),
});

type ValidationSchema = z.infer<typeof validationSchema>;

export const HelpModal = ({
  open,
  handleClose,
  props,
}: {
  open: boolean;
  handleClose: () => void;
  props: any;
}) => {
  const { data: session } = props.useSession();
  const { register, handleSubmit, watch } = useForm<ValidationSchema>({
    resolver: zodResolver(validationSchema),
    mode: "all",
  });

  const values = watch();

  const { mutate, isPending } = props.useMutation({
    mutationFn: props.mutateAction,
    mutationKey: ["help"],
    onSuccess: async (data: any) => {
      if (data.error)
        throw new Error(data.error?.heading, { cause: data?.error?.message });

      props.toast("Your message has been received. Our team will respond to you shortly", { type: "success" });
      handleClose();
    },
    onError: (error: any) => {
      props.toast(error?.cause as string, { type: "error" });
    },
  });

  const onSubmit: SubmitHandler<ValidationSchema> = (data: any) => {
    mutate({
      endPoint: `/project/v2/onboarding/request-help/${props?.projectId}`,
      type: "post",
      data,
      session,
    });
  };

  return (
    <InputModal
      title="Need Help?"
      open={open}
      onClose={handleClose}
      outlinedButtonTitle="Cancel"
      outlinedOnClick={handleClose}
      containedButtonTitle="Submit"
      onSubmit={handleSubmit(onSubmit)}
      loading={isPending}
      disableContainedButton={!values?.message}
    >
      <VeBox width={"100%"} display="flex" flexDirection="column" gap="16px">
        <VeInput
          name="message"
          register={register}
          label="Description"
          multiLineRows={5}
          required
        />
      </VeBox>
    </InputModal>
  );
};
